/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-06-12 10:24:47
 * @LastEditors: wl
 * @LastEditTime: 2020-07-10 14:40:36
 */ 
import axios from '../axios'


/* 
 * 三合力通
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/admin/service/sys_dictionaries_add',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/service/sys_dictionaries_remove',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/getCapabilitylayer_uploadList',
        method: 'post',
        data
    })
}

//小区列表   /admin/service/sys_community_array
export const communityList = (data) => {
    return axios({
        url: '/admin/service/sys_community_array',
        method: 'post',
        data
    })
}
//senseLink小区列表 
export const senseLink_account_info = (data) => {
    return axios({
        url: '/admin/service/senseLink_account_info',
        method: 'post',
        data
    })
}
//获取机构辖区的列表/admin/service/sys_group_array
export const communityDept = (data) => {
    return axios({
        url: '/admin/service/sys_group_array',
        method: 'post',
        data
    })
}
//获取辖区下面的数据/admin/service/getCapabilitylayer_pushStatistics

export const communityAccount = (data) => {
    return axios({
        url: '/admin/service/getCapabilitylayer_pushStatistics',
        method: 'post',
        data
    })
}

//推送预警

export const informWarning = (data) => {
    return axios({
        url: '/admin/service/sys_capabilitylayer_alarm',
        method: 'post',
        data
    })
}

//sys_capabilitylayer_alarm_number
export const getInforNum = (data) => {
    return axios({
        url: '/admin/service/sys_capabilitylayer_alarm_number',
        method: 'post',
        data
    })
}


// 通行统计
export const countCurrent = (data) => {
    return axios({
        url: '/admin/service/sys_count_index',
        method: 'post',
        data
    })
}

// 通行趋势
export const countPass = (data) => {
    return axios({
        url: '/admin/service/sys_count_pass',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/three.js